/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Accepted_DescriptionInputs */

const en_invite_accepted_description = /** @type {(inputs: Invite_Accepted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 coins are ready!`)
};

const ar_invite_accepted_description = /** @type {(inputs: Invite_Accepted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 عملة جاهزة!`)
};

const de_invite_accepted_description = /** @type {(inputs: Invite_Accepted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 Münzen sind bereit!`)
};

const es_invite_accepted_description = /** @type {(inputs: Invite_Accepted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡300 monedas listas!`)
};

const fr_invite_accepted_description = /** @type {(inputs: Invite_Accepted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 pièces sont prêtes !`)
};

const it_invite_accepted_description = /** @type {(inputs: Invite_Accepted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 monete sono pronte!`)
};

const ja_invite_accepted_description = /** @type {(inputs: Invite_Accepted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300コインの準備ができました！`)
};

const ko_invite_accepted_description = /** @type {(inputs: Invite_Accepted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코인 300개가 준비됐어요!`)
};

const pt_br_invite_accepted_description = /** @type {(inputs: Invite_Accepted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 moedas estão prontas!`)
};

const ru_invite_accepted_description = /** @type {(inputs: Invite_Accepted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 монет готовы!`)
};

const th_invite_accepted_description = /** @type {(inputs: Invite_Accepted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 เหรียญพร้อมแล้ว!`)
};

const tr_invite_accepted_description = /** @type {(inputs: Invite_Accepted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 jeton hazır!`)
};

const zh_cn_invite_accepted_description = /** @type {(inputs: Invite_Accepted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 金币已经准备好了！`)
};

const zh_tw_invite_accepted_description = /** @type {(inputs: Invite_Accepted_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`300 金幣已經準備好了！`)
};

/**
* | output |
* | --- |
* | "300 coins are ready!" |
*
* @param {Invite_Accepted_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_accepted_description = /** @type {((inputs?: Invite_Accepted_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Accepted_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_accepted_description(inputs)
	if (locale === "ar") return ar_invite_accepted_description(inputs)
	if (locale === "de") return de_invite_accepted_description(inputs)
	if (locale === "es") return es_invite_accepted_description(inputs)
	if (locale === "fr") return fr_invite_accepted_description(inputs)
	if (locale === "it") return it_invite_accepted_description(inputs)
	if (locale === "ja") return ja_invite_accepted_description(inputs)
	if (locale === "ko") return ko_invite_accepted_description(inputs)
	if (locale === "pt_br") return pt_br_invite_accepted_description(inputs)
	if (locale === "ru") return ru_invite_accepted_description(inputs)
	if (locale === "th") return th_invite_accepted_description(inputs)
	if (locale === "tr") return tr_invite_accepted_description(inputs)
	if (locale === "zh_cn") return zh_cn_invite_accepted_description(inputs)
	return zh_tw_invite_accepted_description(inputs)
});